<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">查询用户总览数据报表</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select style="width: 160px" v-model="channel" placeholder="">
          <el-option
            v-for="(item, itemIndex) in channelsList"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="language"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="platform"
          placeholder=""
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="安卓" :value="1"></el-option>
          <el-option label="ios" :value="2"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="date" fixed label="日期区间" width="200">
        </el-table-column>

        <el-table-column prop="channel" fixed label="渠道" width="180">
        </el-table-column>
        <el-table-column prop="phoneType" label="平台" width="180">
        </el-table-column>

        <el-table-column prop="country" label="国家" width="180">
        </el-table-column>

        <el-table-column prop="language" label="语言" width="180">
        </el-table-column
        ><el-table-column
          prop="dayNewUserCount"
          label="新增"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column
          prop="activeUserCount"
          label="活跃"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column
          prop="activeDeviceCount"
          label="活跃设备"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column
          prop="payUserCount"
          label="充值用户"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column
          prop="highPayUserCount"
          label="高价值用户数"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column prop="payRate" label="充值率" width="180">
        </el-table-column
        ><el-table-column
          prop="payGold"
          label="充值总金币"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column
          prop="payMoney"
          label="充值总金额USD"
          sortable
          width="180"
        >
        </el-table-column
        ><el-table-column prop="usd" label="ARPU-USD" width="180" sortable>
        </el-table-column
        ><el-table-column
          prop="chatCount"
          label="总通话次数"
          sortable
          width="180"
        >
        </el-table-column>

        <el-table-column
          prop="chatGold"
          label="通话消耗总金币数"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="giftGold"
          label="礼物总消耗金币"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column prop="costRate" label="金币消耗率" width="180">
        </el-table-column>
        <el-table-column
          prop="highChatCount"
          label="高价值用户通话次数"
          width="180"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="highChatGold"
          label="高价值用户通话消耗金币"
          width="180"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="highGiftGold"
          label="高价值用户礼物消耗金币"
          width="180"
          sortable
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="10"
      ></el-pagination>
    </el-row>

    <el-row>
      <div class="custom-echart" ref="myChart"></div>
    </el-row>
  </el-card>
</template>

<script>
import echarts from 'echarts'

import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      language: 'all',
      languageList: [],
      channel: 'total',
      channelsList: this.$store.state.channels,
      //   -1 全部  1  安卓  2 ios
      platform: -1,
      myChart: null,
      myOption: {
        title: {
          text: '用户总览数据',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.myChart)
  },
  methods: {
    myChartBuild() {
      //   this.myChart.resize();
    },
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.user_stat,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          country: this.country,
          language: this.language,
          platform: this.platform,
          channel: this.channel
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
      this.dayChatDetailData.map(e => {
        if (e.date == 'total') {
          this.myOption.series[0].data = [
            {
              value: e.payUserCount,
              name: '充值用户'
            },
            {
              value: e.highPayUserCount,
              name: '高价值用户数'
            },
            {
              value: e.chatGold,
              name: '通话消耗总金币数'
            },
            {
              value: e.giftGold,
              name: '礼物总消耗金币'
            },
            {
              value: e.highChatGold,
              name: '高价值用户通话消耗金币'
            },
            {
              value: e.highGiftGold,
              name: '高价值用户礼物消耗金币'
            }
          ]
        }
      })

      this.myChart.setOption(this.myOption)

      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        name: '高价值用户数'
      })
      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        name: '通话消耗总金币数'
      })
      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        name: '礼物总消耗金币'
      })
      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        name: '高价值用户通话消耗金币'
      })
      this.myChart.dispatchAction({
        type: 'legendToggleSelect',
        name: '高价值用户礼物消耗金币'
      })
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.user_stats_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          country: this.country,
          language: this.language,
          platform: this.platform,
          channel: this.channel
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '用户总览数据' + this.platformData[1])
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }

  .custom-echart {
    width: 900px;
    height: 450px;
  }
}
</style>
